import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 * @param organisationId string
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId) {
    var url = applyPathVariables(EndPoints.REPORTS_DEFINITIONS, {
        organisationId: organisationId,
    });
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, data: null, headers: headers });
    return request.execute();
});
